import { useRef } from 'react'
import { PageViewData } from '../GTM.d'

const fieldsToPreserve: Array<keyof PageViewData> = [
    'userLogState',
    'cartContents'
]

export const PageViewDataKeys = ['pageDetails', 'userLogState', 'cartContents']
export const isPageViewDataKey = (str?: string): str is keyof PageViewData => {
    return (
        typeof str === 'string' && Object.values(PageViewDataKeys).includes(str)
    )
}

export const useDataLayerData = () => {
    const dataRef = useRef<PageViewData>({})
    const getStoredData = (): PageViewData => {
        return dataRef.current
    }
    const addStoredData = (data: PageViewData) => {
        dataRef.current = { ...dataRef.current, ...data }
    }
    const resetStoredData = () => {
        Object.keys(dataRef.current).forEach((key) => {
            if (
                isPageViewDataKey(key) &&
                !fieldsToPreserve.includes(key) &&
                typeof dataRef.current[key] !== 'undefined'
            ) {
                delete dataRef.current[key]
            }
        })
    }

    return {
        getStoredData,
        addStoredData,
        resetStoredData
    }
}
